import React from 'react';
import { connect } from 'react-redux';
import FormularioVrp from './FormularioVrp';
import MapaVrp from './MapaVrp';
import { getRoute } from '../actions';


class VrpApp extends React.Component{
    
    componentDidUpdate() {
        if (this.props.response.length >0){
            console.log(this.props.response);
            this.props.getRoute(this.props.response[0].resources[0]);
        }
    }


    render(){
        return (
            <div>
                <h1>Travelling Salesman Problem</h1>
                <h5>App implemented in <code>Python</code> using  <a href="https://developers.google.com/optimization/">OR-Tools</a> and <a href="https://docs.microsoft.com/en-us/bingmaps/v8-web-control/">Bing Maps V8 Web Control</a>  </h5>
                <div className="ui grid">
                        <div className = "row">
                            <div className=" five wide column">
                                <FormularioVrp />
                            </div>
                            <div className="eleven wide column">
                                <MapaVrp/>
                            </div>
                        </div>
                </div>
            </div>
        );
    }
}

//-2.1686,-79.9191;-2.1517,-79.8859;-2.1569,-79.9450;-2.161174, -79.937526;-2.145821, -79.904824;-2.125904, -79.891571;-2.208902, -79.906605

const mapStateToProps = (state) => {
    return {response:state.matrix};
}


export default connect(mapStateToProps,{ getRoute : getRoute })(VrpApp);